import { components } from '@/types/api';
import { BankAccountActivites } from './BankAccountActivities';
import { BenefitProgramActivites } from './BenefitProgramActivites';
import { LoyalityProgramActivites } from './LoyalityProgramActivities';
import { PlaidAccountActivites } from './PlaidAccountActivites';

export function AccountActivities(props: {
  account: components['schemas']['AccountDetailsOutput'];
}) {
  const { account } = props;
  switch (account.type) {
    case 'benefit_program':
      return <BenefitProgramActivites account={account} />;
    case 'bank_account':
    case 'debit_card':
    case 'credit_card':
      return <BankAccountActivites account={account} />;
    case 'loyalty_program':
      return <LoyalityProgramActivites account={account} />;
    case 'plaid_account':
      return <PlaidAccountActivites account={account} />;
    default:
      return null;
  }
}
